/**
 * Route constants for the identity frontend (per-realm)
 */

export const ROUTES = {
  HOME: "/",

  MY_IDENTITY: "/identity",

  MIGRATION: {
    ROOT: "/migration",
    START: "/migration/start",
    WELCOME: "/migration/welcome",
    EMAIL_CONFIRM: "/migration/email-confirm",
    VERIFY: "/migration/verify",
    SUCCESS: "/migration/success",
    ALREADY_MIGRATED: "/migration/already-migrated",
    ERROR: "/migration/error",
    TOKEN_EXPIRED: "/migration/expired",
    EMAIL_ENTRY: "/migration/email-entry",
    SET_PASSWORD: "/migration/set-password",
    SIGN_IN: "/migration/sign-in",
    CONFLICT: "/migration/conflict",
    ALTERNATIVE_EMAIL: "/migration/alternative-email",
    LINK_CALLBACK: "/migration/link-callback",
  },

  /** The wizard of a person who has just registered with the application */
  REGISTRATION: {
    ROOT: "/registration",
    START: "/registration/start",
    VERIFY: "/registration/verify",
    PASSWORD: "/registration/password",
    CONFLICT: "/registration/conflict",
    SUCCESS: "/registration/success",
  },
} as const;

export function buildRoute(
  route: string,
  params: Record<string, string>
): string {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
}
